import type { components } from '@/types/openapi';

export type OrganizationDTO = components['schemas']['Organization'];
export type OrganizationProductsDTO =
  components['schemas']['OrganizationProducts'];
export type ProductDTO = components['schemas']['Product'];
export type OrganizationProductsDTOKeys = keyof OrganizationProductsDTO;

export enum OrganizationType {
  IR = 'IR',
  SALESFORCE = 'Salesforce'
}

export type Organization = OrganizationProductsDTO & {
  product_status: OrganizationProductStatus;
  product_type: string[];
  product_sub_type: string[];
  active_products: number;
  total_users: number;
  type: OrganizationType;
  ai_enabled?: string;
};

export type ProductType = ProductDTO & {
  active: boolean;
};

export type OrganizationsProductsType = OrganizationProductsDTO & {
  products: ProductType[];
};

export type OrganizationProductStatus = 'Active' | 'Expiring Soon' | 'Expired';

export type OrganizationIdNames = {
  [key: number]: string;
};
